import AOS from 'aos';
import { useEffect } from "react";
import SectionTitle from "../../CommonComponents/SectionTitle.jsx/SectionTitle";
import about_img from "../../../images/about/about-2.png";
import vission from '../../../images/about/vission.png';
import './about.css';

export default function About() {

 useEffect(()=>{
  AOS.init();
  AOS.refresh();
},[])

 return (
  <section className="about_section pt-5" id="about">
    <div className="container pt-0">       
      <div className="row about_wrapper">            
          <div className="col-md-3" data-aos="fade-down"  data-aos-delay="200">
            <img className="img-fluid"  src={about_img} alt="" />
          </div>
          <div className="col-md-9" data-aos="fade-up"  data-aos-delay="200">        
            <SectionTitle
              title="About us"
              detail="Welcome to Doctor Care, where the convergence of compassionate healthcare and cutting-edge technology forms the foundation of our mission. We are a dedicated team of healthcare professionals committed to providing exceptional medical services with a strong focus on patient-centric care.

Our journey began with a vision to redefine healthcare. Today, we stand as a trusted name in the industry, delivering a wide range of healthcare services that cater to the diverse needs of our patients. Our experienced and compassionate staff, along with a team of expert doctors, ensure that your well-being is our utmost priority."
            />          
          </div>
          <div className="col-md-3" data-aos="fade-down"  data-aos-delay="400">
            <img className="img-fluid"  src={vission} alt="" width="80%" style={{paddingLeft:"60px"}}/>
          </div>
          <div className="col-md-9" data-aos="fade-up"  data-aos-delay="400">         
            <SectionTitle
              title="Our vission"
              detail="At Doctor Care, our vision transcends conventional healthcare. We aspire to be the cornerstone of trust, innovation, and compassion in the medical field. Our unwavering commitment is to serve as your dedicated healthcare partner, offering a full spectrum of comprehensive and accessible medical solutions.

We envision a world where every individual can access high-quality healthcare with ease. We strive to enhance the quality of life for our patients by integrating cutting-edge technology with personalized care, all while fostering a warm and nurturing environment."
            />         
          </div>                   
      </div>        
    </div>
</section>
 )
}
